module.exports = __webpack_public_path__ + "img/gym.f5a3ef5c.jpg";